import auth from '@/utils/auth';
import { HTTP_DESKRH, HTTP_DOCUMENTS, HTTP_ORGANIZATIONS } from '../http';

export default {

  getFolders(context, searchRequest) {
    return HTTP_DOCUMENTS.post('/folders', searchRequest)
      .then(response => response.data.data);
  },

  getDocuments(context, requestParameters) {
    return HTTP_DOCUMENTS.post(`/${process.env.API_DOCUMENTS_LISTING_ROUTE}`, requestParameters)
      .then(response => response.data.data);
  },

  getDocument(id) {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_ROUTE}/${id}`)
      .then(response => response.data.data);
  },

  getDocumentsSenders() {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_LISTING_ROUTE}/senders`)
      .then(response => response.data.data);
  },

  getDocumentContent(context, documentId) {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_ROUTE}/pdf/${documentId}`, {
      responseType: 'arraybuffer',
      headers: { Accept: 'application/octet-stream' },
      timeout: process.env.ARCHIVE_TIMEOUT,
    })
    .then(response => response.data);
  },

  getDocumentAttestation(context, documentId) {
    return HTTP_DOCUMENTS.get(`${process.env.API_DOCUMENTS_ROUTE}/attestation/${documentId}`, {
      responseType: 'arraybuffer',
      headers: { Accept: 'application/octet-stream' },
      timeout: process.env.ARCHIVE_TIMEOUT,
    })
      .then(response => response.data);
  },

  getDocumentDetails(context, documentId) {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_ROUTE}/${documentId}/location`)
      .then(response => response.data.data);
  },

  getArchive(context, documentIds) {
    return HTTP_DOCUMENTS.post(`/${process.env.API_DOCUMENTS_ROUTE}/pdf/archive`, documentIds, {
      responseType: 'arraybuffer',
      headers: { Accept: 'application/octet-stream' },
      timeout: process.env.ARCHIVE_TIMEOUT,
    })
    .then(response => response.data);
  },

  getStats() {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_LISTING_ROUTE}/stats`)
      .then(response => response.data);
  },

  getPdf(description, id) {
    return HTTP_DOCUMENTS.get(`/${process.env.API_DOCUMENTS_ROUTE}/${id}/preview/${description}`, {
      responseType: 'blob',
      headers: {
        Accept: 'application/pdf',
      } })
      .then(data => data);
  },

  getDocTypes() {
    const orgId = auth.getOrgId();
    return HTTP_ORGANIZATIONS.get(`/organization/${orgId}/conf/doc-type`)
      .then(data => data);
  },

  getDocType(code) {
    return HTTP_DOCUMENTS.get(`/doc-types/${code}`)
      .then(data => data);
  },

  setDocRead(id) {
    return HTTP_DOCUMENTS.post(`/${process.env.API_DOCUMENTS_ROUTE}/${id}/setRead`)
      .then(data => data.data.data)
      .catch(error => console.log(error));
  },

  docUpload(jsonDoc, file) {
    const formData = new FormData();
    formData.append(file.id, file.file, `${file.type}:${file.description}`);
    formData.append('json', JSON.stringify(jsonDoc));
    const config = {
      headers: { 'content-type': 'multipart/form-data' },
    };
    return HTTP_DOCUMENTS.post(`/${process.env.API_DOCUMENTS_ROUTE}/upload`, formData, config)
      .then(data => data);
  },

  sendChorusMetaValidation(docId, metaDatas) {
    return HTTP_DOCUMENTS.post(`/${process.env.API_DOCUMENTS_ROUTE}/${docId}/chorusValidation`, { metaDatas });
  },
  requestNewDocDirectDownloadLink(token) {
    return HTTP_DESKRH.post('/regenerate-direct-doc-download', { token });
  },
};



// WEBPACK FOOTER //
// ./src/api/documents.js